import { usePushNotification as useContextPushNotification } from 'src/contexts/push-notification-context'

export const usePushNotification = () => useContextPushNotification()
